import { Pick } from '@40seas/entities/common';
import { HeronReport } from './heron-report.entity';

export class CreateHeronReportDto extends Pick(HeronReport, ['heronCompany', 'buyer']) {}
